import type { HandoffNotice } from '../types/chat';

export function formatHandoffNotice(handoff?: HandoffNotice): string {
  const target = handoff?.target || 'human';
  const queue = handoff?.queue_name?.trim();

  switch (target) {
    case 'bot':
      return 'Transferring you now.';
    case 'phone':
      return 'Connecting you by phone.';
    case 'none':
      return 'This conversation is being wrapped up.';
    case 'human':
    default:
      return queue ? `Connecting you to ${queue}.` : 'Connecting you to a human agent.';
  }
}
